import React from 'react';

import * as classes from './style.module.scss';

interface Props {
  image: boolean;
}
export const Grid3: React.FC<Props> = ({ image, children }) => {
  const wrapperClass = image ? classes.imgWrapper : classes.gridWrapper;

  return (
    <div className={classes.mainWrapper}>
      <div className={wrapperClass}>{children}</div>
    </div>
  );
};
